export const getRuntimeEnvironment = () =>
  window.location.host === 'www.iwoca.co.uk' ? 'production' : 'staging';
